<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link class="navbar-brand" to="/home"></b-link>
    <button class="navbar-toggler sidebar-minimizer d-md-down-none h-100 b-r-1" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-form class="form-inline float-left px-4 d-md-down-none">
      <i class="fa fa-search"></i>
      <Input class="form-control" v-bind:placeholder="$t('are_you_looking_for_something')" />
    </b-form>
    <b-navbar-nav class="ml-auto">
      <div class="main-language">
        <change-language></change-language>
      </div>
      <HeaderDropdownAccnt/>
    </b-navbar-nav>
  </header>
</template>

<style scoped>
  .main-language {
    margin-top: 15px;
  }
  .app-header.navbar .navbar-brand {
    background-image: url("~/static/img/logo_wide%40x2.png");
    background-size: 80% auto;
  }
</style>

<script>
  import HeaderDropdownAccnt from './HeaderDropdownAccnt.vue'
  import ChangeLanguage from '../Partials/ChangeLanguages.vue'

  export default {
    name: 'c-header',
    components: {
      HeaderDropdownAccnt,
      ChangeLanguage
    },
    methods: {
      sidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-hidden')
      },
      mobileSidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header/Header.vue